import { globalConstants } from "../constants";
import {
  getRequestWithParams,
  postRequestWithFiles,
  putRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getProfileImageUrl(systemUserId) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/user/profile/picture/${systemUserId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getProfileData(systemUserId) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/user/profile/${systemUserId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function UploadProfilePic(formData) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/user/profile/picture`,
    formData
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateProfile(userUpdatedData) {
  return putRequest(
    `/${globalConstants.VERSION}/admin/User`,
    userUpdatedData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const profileService = {
  getProfileImageUrl,
  UploadProfilePic,
  getProfileData,
  updateProfile,
};
